<input #currencyMask [(ngModel)]="value" (ngModelChange)="onChange()" [options]="currencyMaskOptions" class="currency-mask" currencyMask>
